const Resources = {

    table_headers: [
        { 
            text: 'Assignment #',
            align: 'start',
            value: 'number_assigment',
            type: 'link',
        },
        { 
            text: 'Assignment',
            align: 'start',
            value: 'description',
            type: 'link',
        },
        { 
            text: 'Associate',
            value: 'name_concat',
        },
        {   
            text: 'Total Rooms',
            value: 'total_rooms_today',
        },
        {   
            text: 'Cleaned Rooms',
            value: 'total_rooms_cleaned',
            type: 'text_link_action'
        },
        {   
            text: 'Rooms Left to Clean',
            value: 'total_rooms_not_cleaned',
            type: 'text_link_action'
        },
        {   
            text: '%Complete',
            value: 'complete',
            type: 'percentage'
        },
        {   
            text: 'Rooms',
            value: 'View Rooms',
            type: 'link_action_with_href'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignment Status',
            href:   '/assignment-statuses',
            arrow:  "",
        },
    ],


    room_table_headers: 
    [
        { 
            text: 'Room',
            align: 'start',
            value: 'room',
        },
        { 
            text: 'Task',
            align: 'start',
            value: 'task',
        },
        { 
            text: 'Daily Assignment',
            align: 'start',
            value: 'daily_assignment',
        },
    ],

    room_table_headers_2: 
    [
        { 
            text: 'Room',
            align: 'start',
            value: 'room',
        },
        { 
            text: 'Task',
            align: 'start',
            value: 'task',
        },
    ],

}

export default Resources;